import { AxiosResponse } from "axios";
import { axiosInstance } from "./axiosInstance";

const base = (campusId: number) => `/admin/campus/${campusId}`;

export interface PlatformPriceDTO { currencyId: number; code: string; symbol: string; defined: boolean; monthlyPrice: number | null; }
export interface PlatformCourseDTO { courseId: number; code: string; name: string; statusId: number; campusCurrencyId: number; planMonthlyPrice: number | null; prices: PlatformPriceDTO[]; activeSubscriptions: number; }
export interface PlatformAccessDTO { accessUntil: string | null; nextRenewalOn: string | null; tuitions: { id: number; title?: string; startDate?: string; dueDate?: string; isGift: boolean; note: string | null; [k: string]: any }[]; }

/** Plataformas (FASE 4): precio mensual por moneda, acceso y "regalar mes". Sale apagado (PLATAFORMAS_ACTIVAS). */
export class PlatformsService {
	list = async (campusId: number): Promise<AxiosResponse<PlatformCourseDTO[]>> => axiosInstance.get<PlatformCourseDTO[]>(`${base(campusId)}/courses/_platforms`);

	/** monthlyPrice null = sin precio en esa moneda (matricular da 422). */
	setPrice = async (campusId: number, courseId: number, currencyId: number, monthlyPrice: number | null): Promise<AxiosResponse<any>> =>
		axiosInstance.put(`${base(campusId)}/courses/_platformPrice`, { courseId, currencyId, monthlyPrice });

	access = async (campusId: number, enrollmentId: number): Promise<AxiosResponse<PlatformAccessDTO>> =>
		axiosInstance.get<PlatformAccessDTO>(`${base(campusId)}/enrollments/_platformAccess`, { params: { enrollmentId } });

	/** La mensualidad pendiente sin abonos queda en 0 "Regalo: <nota>"; si no hay, regala el mes siguiente. */
	gift = async (campusId: number, enrollmentId: number, note: string): Promise<AxiosResponse<any>> =>
		axiosInstance.post(`${base(campusId)}/enrollments/_platformGift`, { enrollmentId, note });
}

const platformsService = new PlatformsService();
export default platformsService;
